<vectronic-card [title]="'About My VECTRONIC'">
  <ng-container body>
    <mat-dialog-content class="dialog-body">
      <p>My VECTRONIC Version: {{ myVectronicVersion }}</p>
      <p>Developed by VECTRONIC Aerospace</p>
    </mat-dialog-content>
  </ng-container>
</vectronic-card>
